import { render, staticRenderFns } from "./wrappImg.vue?vue&type=template&id=1c8b25e6&scoped=true&"
import script from "./wrappImg.vue?vue&type=script&lang=js&"
export * from "./wrappImg.vue?vue&type=script&lang=js&"
import style0 from "./wrappImg.vue?vue&type=style&index=0&id=1c8b25e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b25e6",
  null
  
)

export default component.exports